export const isLoggedSelector = (state) => state.userAuthReducer.isLogged;
export const uidSelector = (state) => state.userAuthReducer.uid;
export const emailSelector = (state) => state.userAuthReducer.email;
export const permissionsSelector = (state) => state.userAuthReducer.permissions;
//
export const registerSelector = (state) => state.userAuthReducer.register;
export const registerStepSelector = (state) => state.userAuthReducer.step;
export const registerLastMailSelector = (state) =>
  state.userAuthReducer.lastMail;
